// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning_warning__24qVy","cloudtail":"warning_cloudtail__316fi","form":"warning_form__1hfMt","title":"warning_title__3Ml28"};